import React from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import EssPunchData from '../components/EssPunchData'


function EssAttendancePage() {
  return (
    <EssLayout>
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-12'>
                  <EssPunchData/>
                </div>
                <div className='col-md-6'></div>
            </div>
        </div>
    </EssLayout>
  )
}

export default EssAttendancePage